import Vue from 'vue';
const OfferAnalysis = new Vue();
export default OfferAnalysis;
